module.exports = __webpack_public_path__ + "img/payment-variants.64156bcd.png";